import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import NotificationIcon from '../../assets/img/notif-bell.svg';
import moment from 'moment-timezone';
import styled from "styled-components";

const CustomAlert = styled(Alert)`
    background: ${props => props.backgroundcolor} !important;
`;

export const NotificationBanner = (props) => {

    const { brand } = props;

    const calculateTimeLeft = () => {
        var d = new Date();
        var m = moment.utc(d).tz("America/New_York");
        const today = moment.utc(d).tz("America/New_York");
        m.set({ hour: 17, minute: 30, second: 0, millisecond: 0 });
        m.toISOString();
        let difference = +new Date(m.format()) - +new Date(today.format());

        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }

        return timeLeft;
    };

    // eslint-disable-next-line no-unused-vars
    const [show, setShow] = useState(true);
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearTimeout(timer);
    });

    const timerComponents = [];

    Object.keys(timeLeft).forEach((interval, index) => {
        if (!timeLeft[interval]) {
            return;
        }

        timerComponents.push(
            <span key={index}>
                {timeLeft[interval]} {interval}{" "}
            </span>
        );
    });

    return (
        <>
            <CustomAlert
                backgroundcolor={brand?.colors?.theme}
                className="notificationBanner"
                onClose={() => setShow(false)} >
                <div className="d-flex align-items-center">
                    <img className="bannerIcon" src={NotificationIcon} alt="Banner" />
                    <div className="banner-text">
                        {timerComponents.length > 0 ?
                            <span>Place your order by 5:30 PM EST for guaranteed overnight shipping! {timerComponents}</span>
                            :
                            <span>Order will ship the following business day</span>
                        }
                    </div>
                </div>
            </CustomAlert>
        </>
    )
}